import { Injectable } from '@angular/core';
import { ConfigAuth, IConfigAuth } from '../interfaces/config.auth';
import { ConfigCommChannel, IConfigCommChannel } from '../interfaces/config.comm.channel';
import { ConfigCore, IConfigCore } from '../interfaces/config.core';
import { ConfigData, IConfigData } from '../interfaces/config.data';
import { ConfigLogging, IConfigLogging, LogLevel } from '../interfaces/config.logging';
import { ConfigSystem, IConfigSystem } from '../interfaces/config.system';

export interface IConfigService {

    configAuth: IConfigAuth;
    configCommChannel: IConfigCommChannel;
    configCore: IConfigCore;
    configData: IConfigData;
    configLogging: IConfigLogging;
    configSystem: IConfigSystem;

}

@Injectable({
    providedIn: 'root'
})
export class ConfigService implements IConfigService {

    constructor() {
        if (ConfigCore.configLogging.logLevel === LogLevel.Debug) {
            console.debug('ConfigurationService --> constructor');
        }
    }

    public get configAuth(): IConfigAuth {
        return ConfigAuth;
    }

    public set configAuth(value: IConfigAuth) {
        ConfigAuth.assign(value);
    }

    public get configCommChannel(): IConfigCommChannel {
        return ConfigCommChannel;
    }

    public set configCommChannel(value: IConfigCommChannel) {
        ConfigCommChannel.assign(value);
    }

    public get configCore(): IConfigCore {
        return ConfigCore;
    }

    public set configCore(value: IConfigCore) {
        ConfigCore.assign(value);
    }

    public get configData(): IConfigData {
        return ConfigData;
    }

    public set configData(value: IConfigData) {
        ConfigData.assign(value);
    }

    public get configLogging(): IConfigLogging {
        return ConfigLogging;
    }

    public set configLogging(value: IConfigLogging) {
        ConfigLogging.assign(value);
    }

    public get configSystem(): IConfigSystem {
        return ConfigSystem;
    }

    public set configSystem(value: IConfigSystem) {
        ConfigSystem.assign(value);
    }

}
